import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withStyles } from 'tss-react/mui';

import { accountsUtils } from 'app-components/flux/accounts';
import { getFieldString } from 'data/transactions/utils';

const styles = (theme) => ({
  root: {
    maxWidth: 250,
    minHeight: 60,
    padding: 6,
    boxShadow: `0px 0px 7px ${theme.palette.border.main}`,
    display: 'flex',
    flex: '2 1 0%',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  txnLine: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'noWrap',
    textOverflow: 'ellipsis',
  },
  textStyleLeft: {
    flex: 2,
  },
  textStyleRight: {
    flex: 1,
    flexShrink: 0,
    textAlign: 'right',
  },
  bottomRow: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
  },
});

class MiniTxnCard extends PureComponent {
  render() {
    const { classes, txn, ...props } = this.props;

    return (
      <div {...props}>
        <div className={classes.root}>
          <div className={classes.txnLine}>
            <Typography className={classes.textStyleLeft} noWrap>
              {' '}
              {txn.payee}{' '}
            </Typography>
            <Typography className={classes.textStyleRight}>{getFieldString('amount', txn)}</Typography>
          </div>
          <div className={classes.txnLine}>
            <Typography className={classNames(classes.textStyleLeft, classes.bottomRow)} noWrap>
              {accountsUtils.getAccountString(txn.accountId)}
            </Typography>
            <Typography className={classNames(classes.textStyleRight, classes.bottomRow)}>
              {getFieldString('date', txn)}
            </Typography>
          </div>
        </div>
      </div>
    );
  }
}

MiniTxnCard.propTypes = {
  classes: PropTypes.object.isRequired,
  txn: PropTypes.object,
};

export default withStyles(MiniTxnCard, styles);
